import { Duration } from "luxon";

import { generateServiceId } from "@core/domains/identity";

export const MONITORING_SERVICE = {
  ID: generateServiceId("monitoring"),
  LABEL: "status",
  PROBE_INTERVAL: Duration.fromObject({ minutes: 15 }),
  PROBE_MATCH_TOLERANCE: Duration.fromObject({ minutes: 2 }),
  PROBE_RETENTION: Duration.fromObject({ days: 7 }),
} as const;
